import { Provider } from '@angular/core';
import {
    TRADING_PROCEDURE_LIST_QUERY_TOKEN,
    TRADING_PROCEDURE_LIST_EVENTS_TOKEN
} from '../../../features/trading-procedure-list/application/tokens/tokens';
import {
    TradingProcedureListQueryPort
} from '../../../features/trading-procedure-list/application/ports/trading-procedure-list-query.port';
import { TradingProcedureListQueryAdapter } from './http/trading-procedure-list-query.adapter';
import {
    TradingProcedureListEventsPort
} from '../../../features/trading-procedure-list/application/ports/trading-procedure-list-events.port';
import { TradingProcedureListEventsAdapter } from './web-sockets/trading-procedure-list-events.adapter';

export function provideTradingProcedureListInfrastructure(): Provider[] {
    return [
        {
            provide: TRADING_PROCEDURE_LIST_QUERY_TOKEN,
            useFactory: (): TradingProcedureListQueryPort => new TradingProcedureListQueryAdapter()
        },
        {
            provide: TRADING_PROCEDURE_LIST_EVENTS_TOKEN,
            useFactory: (): TradingProcedureListEventsPort => new TradingProcedureListEventsAdapter()
        }
    ]
}
